import ApiService from "@/core/services/api.service";

//Actions
export const FETCH_GPS_TANKS = "fetchGpsTanks";

export const SET_LOADING = "setLoadingGpsTank";

const state = {
  isLoadingGpsTank: false
};

const getters = {
  isLoadingGpsTank() {
    return state.isLoadingGpsTank;
  },
};

const actions = {
  [FETCH_GPS_TANKS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("gps-tanks" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
};

const mutations = {
  [SET_LOADING](state, value) {
    state.isLoadingGpsTank = value;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
